import { FormGroupDefinition, FormNode } from '@msdk/definitions'
import React, { ReactNode } from 'react'

import { CustomGroup, FrameworkGroup } from './Groups'

interface Props {
  node: FormNode
  children?: ReactNode[]
}

export function Group({ node, children }: Props) {
  const groupDef = node.value.formDefinition as FormGroupDefinition

  return (
    <>
      {groupDef.customUI && <CustomGroup node={node}>{children}</CustomGroup>}
      {!groupDef.customUI && <FrameworkGroup node={node}>{children}</FrameworkGroup>}
    </>
  )
}
